import React from "react";
import {
    Badge,
    Card,
    Group,
    SegmentedControl,
    Stack,
    Text,
    Title,
} from "@mantine/core";
import type { EventDto, Language, PersonDto } from "../types";
import type { Texts } from "../texts";

type Props = {
    eventInfo: EventDto | null;
    personInfo: PersonDto | null;
    eid: number;
    pid: number;
    language: Language;
    setLanguage: (language: Language) => void;
    t: Texts;
    functions?: string[];
};

export default function HeaderCard({
    eventInfo,
    personInfo,
    eid,
    pid,
    language,
    setLanguage,
    t,
    functions = [],
}: Props) {
    return (
        <Card withBorder padding="md" radius="md">
            <Group justify="space-between" align="flex-start">
                <Stack gap={6}>
                    <Title order={3} style={{ lineHeight: 1.2 }}>
                        {eventInfo?.eventName ?? "Event"}
                    </Title>

                    <Group gap="xs">
                        <Badge color="red" variant="light">
                            {t.eventId}: {eid}
                        </Badge>

                        <Badge color="red" variant="light">
                            {t.personId}: {pid}
                        </Badge>

                        <Badge color="red" variant="dot">
                            {t.myPage}
                        </Badge>
                    </Group>

                    <Text c="dimmed" size="sm">
                        {personInfo
                            ? `${personInfo.firstName} ${personInfo.lastName}`.trim()
                            : ""}
                    </Text>

                    {functions.length > 0 && (
                        <Group gap={5} mt={2}>
                            {functions.map((name, index) => (
                                <Badge
                                    key={`${name}-${index}`}
                                    size="sm"
                                    color="gray"
                                    variant="light"
                                >
                                    {name}  {index}
                                </Badge>
                            ))}
                        </Group>
                    )}
                </Stack>

                <SegmentedControl
                    size="xs"
                    value={language}
                    onChange={(value) => setLanguage(value as Language)}
                    data={[
                        { label: t.languageDa, value: "da" },
                        { label: t.languageEn, value: "en" },
                    ]}
                />
            </Group>
        </Card>
    );
}